import axiosInstance from "../../../../config/axios-config";

async function createProject(url, jwtToken, projectDetails, toast, navigate) {
    try {
        const response = await toast.promise(axiosInstance.post(url, projectDetails, {
            headers: {
                "Authorization": `Bearer ${jwtToken}`,
            }
        }), {
            pending: `This ${projectDetails.projectType} project creation is in progress.`,
            success: `This ${projectDetails.projectType} project has been successfully created.`,
            error: `Error occured while creating this ${projectDetails.projectType} project. Please try again.`
        });

        const data = await response.data;
        
        // navigate user
        if(data === 'OK') {
            setTimeout(() => navigate("/teacher/ongoing-projects", {replace: true}), 1500);
        }
    } catch(err) {
        // console.log(err);   
    }
}

export { createProject };